<template>
<div>
        <div class="modal fade" id="modalAutoSave" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-title-pink">
                        <p class="modal-title">
                            {{
                                {
                                    ru: 'Сохраните форму перед выходом',
                                    kz: 'Шығар алдында пішініңізді сақтаңыз.',
                                    en: 'Save your form before you go out',
                                }[getLang()]
                            }}
                        </p>
                        <a class="close" @click="cancel">
                            <span aria-hidden="true">&times;</span>
                        </a>
                    </div>
                    <div class="modal-body">
                        {{
                            {
                                ru: 'Сохраните форму перед выходом, иначе все заполненные данные будут потеряны.',
                                kz: 'Шығар алдында пішінді сақтаңыз, әйтпесе барлық толтырылған деректер жоғалады.',
                                en: 'Please save the form before exiting, otherwise all completed data will be lost.',
                            }[getLang()]
                        }}
                    </div>
                </div>
            </div>
        </div>
</div>
</template>

<script>
export default {
    name: 'ModalAutoSave',
    mounted() {
        window.onbeforeunload = () => ($('#modalAutoSave').modal('show'));
        // this.leaving;
    },
    methods: {
        cancel() {
            $('#modalAutoSave').modal('toggle');
        },
    },
};
</script>

<style scoped>
.close {
    text-decoration: none;
    color: #424141;
    cursor: pointer;
}
</style>
